export default __webpack_public_path__ + "static/10565-2a98fd633b244fe2012066052b60b4cf.jpg";